export default function () {
  const widgetName = 'seoWidget';
  const widgetOpts = seoWidgetOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,

    cardWidgetLoaded: function (data) {
      $(`#${widgetName} .card-widget-item`).each(function () {
        const widgetData = data.items;
        let mainTitleWidget = widgetData[0].Title;
        $(this).find('.card-widget-title').remove();
        $(this).prepend(
          `<h1 class="card-widget-title" aria-label="${mainTitleWidget}">         
            ${mainTitleWidget}
          </h1>`,
        );

        $(this).find('.buttonwrap .moreButton').addClass('button');
        $(this).find('.buttonwrap .button').removeClass('moreButton');
        $(this).find('.buttonwrap .button').removeAttr('target');
      });
    },

    buyNowButton: {
      visible: false,
      text: 'BUY NOW',
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: false,
    imageIsBackground: false,
    link: [''],
    maxItemsVisible: 1,
    moreButton: {
      visible: true,
      text: 'Learn More',
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: true,
    textOverImage: true,
  });
}
